import React from 'react';
import { Icon } from './Icon.js';
export const IconShareRight = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M12 12L12 11C12 8.23858 14.2386 6 17 6L22 6L21 6", stroke: "currentColor", strokeWidth: "2", strokeMiterlimit: "10", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M18.5 2.5L22 6L18.5 9.5", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "square", fill: "none" }),
        React.createElement("path", { d: "M13.127 4C12.2118 4.50743 11.4073 5.18891 10.7568 6H4V20H18V14.2432L20 12.2432V22H2V4H13.127Z", fill: "currentColor", "data-color": "color-2", "data-stroke": "none" })));
};
//# sourceMappingURL=IconShareRight.js.map